export type GraphQLResponse<T> = {
    data?: T;
    errors?: unknown[];
};

async function fetchGraphQL<T>(query: string, preview = false): Promise<GraphQLResponse<T> | undefined> {
    if (!import.meta.env.VITE_CONTENTFUL_SPACE || !import.meta.env.VITE_CONTENTFUL_TOKEN) {
        console.error('Contentful space and token are required');
        return undefined;
    }
    return fetch(`https://graphql.contentful.com/content/v1/spaces/${import.meta.env.VITE_CONTENTFUL_SPACE}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${preview ? import.meta.env.VITE_CONTENTFUL_PREVIEW_TOKEN : import.meta.env.VITE_CONTENTFUL_TOKEN}`,
        },
        body: JSON.stringify({ query }),
        // cache: import.meta.env.ENV === 'dev' ? 'no-store' : undefined,
    })
        .then(async (response) => {
            const json = await response.json();
            if (json.errors) {
                console.error('Contentful returned errors', JSON.stringify(json.errors, null, 2));
            }
            return json;
        })
        .catch((error) => {
            console.error(error);
            throw error;
        });
}

export function isPreview(): boolean {
    return import.meta.env.VITE_CONTENTFUL_PREVIEW === 'true';
}

export default fetchGraphQL;
